import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as jointUse from '../joint-use'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: jointUse.RESOURCE.payload.dimension.partialId,
      partialId: jointUse.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Snapshot,
    }),
    description: 'Organization joint use calculation mode',
    isOptional: true,
    name: 'Calculation Mode',
    partialId: PartialId.Standard.create('calculation_mode'),
    type: {
      enumId: core.dms.models.Enum.Id.from(
        enums.orgJointUseCalculationMode.RESOURCE.payload,
      ),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
